



import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PressAndMedia from './PressAndMedia';
// Counter Component
const Counter = ({ end, suffix = '', duration = 2000 }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  useEffect(() => {
    if (isInView) {
      let start = 0;
      const increment = end / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(start));
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [isInView, end, duration]);

  return <span ref={ref}>{count}{suffix}</span>;
};

const Home = () => {
  const [countUp, setCountUp] = useState({ traffic: 0, keywords: 0, leads: 0 });

  useEffect(() => {
    const duration = 2000;
    const steps = 60;
    const interval = duration / steps;
    
    let step = 0;
    const timer = setInterval(() => {
      step++;
      const progress = step / steps;
      setCountUp({
        traffic: Math.floor(75 * progress),
        keywords: Math.floor(100 * progress),
        leads: Math.floor(150 * progress)
      });
      if (step >= steps) clearInterval(timer);
    }, interval);

    return () => clearInterval(timer);
  }, []);


const TestimonialSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      text: "After trying multiple marketing agencies, a colleague recommended Docmize. This has been the best decision for my clinic! They helped increase my patient appointments by 3x within 4 months. Highly professional team!",
      name: "Dr. Nirbhay Kataria",
      image: "https://ui-avatars.com/api/?name=Nirbhay+Kataria&background=19354a&color=fff"
    },
    {
      text: "We have been working with Docmize for almost two years now. Their team helped optimize our hospital website and significantly increased patient inquiries from 20 to 80 per month. Very responsive and knowledgeable about healthcare marketing.",
      name: "Dr. Ram Kumar",
      image: "https://ui-avatars.com/api/?name=Ramgopal+Kumar&background=4facfe&color=fff"
    },
    {
      text: "Docmize transformed our clinic's online presence completely. Our Google rankings improved dramatically and we now get 50+ patient calls every week. Their understanding of medical SEO is exceptional!",
      name: "Dr. Priya Sharma",
      image: "https://ui-avatars.com/api/?name=Priya+Sharma&background=43e97b&color=fff"
    },
    {
      text: "The best healthcare marketing agency we've worked with. Their data-driven approach helped us understand our patient demographics better. Our clinic revenue increased by 60% in the first 6 months.",
      name: "Dr. Vikram Singh",
      image: "https://ui-avatars.com/api/?name=Vikram+Singh&background=f5576c&color=fff"
    },
    {
      text: "Exceptional service! Docmize's team understood our dental practice needs perfectly and delivered a customized strategy. We now rank #1 for 'dentist near me' in our city. Incredible results!",
      name: "Dr. Arjun Mehta",
      image: "https://ui-avatars.com/api/?name=Arjun+Mehta&background=667eea&color=fff"
    },
    {
      text: "Working with Docmize has been a game-changer for our multi-specialty hospital. They managed our online reputation beautifully and our Google reviews went from 3.5 to 4.8 stars. Truly remarkable!",
      name: "Dr. Sneha Patel",
      image: "https://ui-avatars.com/api/?name=Sneha+Patel&background=f7931e&color=fff"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 2) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const currentTestimonials = [
    testimonials[currentIndex],
    testimonials[(currentIndex + 1) % testimonials.length]
  ];

  return (
    <div className="grid md:grid-cols-2 gap-6">
      {currentTestimonials.map((testimonial, index) => (
        <motion.div
          key={currentIndex + index}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          className="bg-white rounded-xl p-8 shadow-lg border border-gray-100 min-h-[280px] flex flex-col justify-between"
        >
          <p className="text-gray-800 text-sm leading-relaxed mb-6">
            {testimonial.text}
          </p>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img 
                src={testimonial.image} 
                alt={testimonial.name}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <p className="font-semibold text-gray-900">{testimonial.name}</p>
              </div>
            </div>
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <svg key={i} className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                </svg>
              ))}
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

const [discoveryFormData, setDiscoveryFormData] = useState({
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  service: '',
  message: ''
});

const [isSubmittingDiscovery, setIsSubmittingDiscovery] = useState(false);

const handleDiscoverySubmit = async (e) => {
  e.preventDefault();
  setIsSubmittingDiscovery(true);

  try {
    const response = await fetch('http://localhost:5000/api/contact/discovery-call', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(discoveryFormData),
    });

    const data = await response.json();

    if (data.success) {
      alert(data.message);
      setDiscoveryFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        service: '',
        message: ''
      });
    } else {
      alert(data.message || 'Something went wrong. Please try again.');
    }
  } catch (error) {
    console.error('Error:', error);
    alert('Failed to submit form. Please make sure the backend server is running on port 5000.');
  } finally {
    setIsSubmittingDiscovery(false);
  }
};

// How We Work Section Component
const HowWeWorkSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const steps = [
    {
      title: "Understanding",
      image: "/images/brand4.png",
      description: "We begin by deeply understanding your business, goals, target audience, and current digital presence. Our team conducts thorough research and analysis to identify opportunities and challenges. This foundation helps us create a customized strategy that aligns perfectly with your business objectives."
    },
    {
      title: "Brainstorming",
      image: "/images/brand5.png",
      description: "After understanding your company, we work hand in hand with our team to pitch and bring ideas to the table for brainstorming. Here, our team of experts picks the best idea that can help your company achieve its ultimate vision."
    },
    {
      title: "Implementation",
      image: "/images/brand6.png",
      description: "Once the strategy is finalized, our expert team begins the implementation phase. We execute each element of the plan with precision, whether it's SEO optimization, content creation, social media campaigns, or paid advertising. Every step is monitored to ensure quality delivery."
    },
    {
      title: "Maintenance",
      image: "/images/brand4.png",
      description: "Digital marketing is an ongoing process. We continuously monitor, analyze, and optimize your campaigns to ensure sustained growth. Our team provides regular reports and insights, making adjustments as needed to maximize your ROI and keep you ahead of the competition."
    }
  ];

  return (
    <section className="pt-0 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] text-center mb-12"
        >
          How We Work?
        </motion.h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              onMouseEnter={() => setActiveIndex(index)}
              onClick={() => setActiveIndex(index)}
              className={`relative rounded-xl p-6 cursor-pointer transition-all duration-300 flex flex-col items-center justify-center min-h-[180px] border-2 ${
                activeIndex === index 
                  ? 'bg-[#19354a] border-[#19354a]' 
                  : 'bg-gray-50 border-gray-200 hover:border-[#19354a]'
              }`}
            >
              <motion.div
                animate={{ 
                  scale: activeIndex === index ? 1.1 : 1,
                }}
                transition={{ duration: 0.3 }}
                className="mb-4"
              >
                <img 
                  src={step.image} 
                  alt={step.title}
                  className="w-16 h-16 object-contain"
                  loading="eager"
                />
              </motion.div>
              <h3 className={`text-lg font-semibold text-center ${
                activeIndex === index ? 'text-white' : 'text-[#19354a]'
              }`}>
                {step.title}
              </h3>
            </motion.div>
          ))}
        </div>

        <motion.div 
          key={activeIndex}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="bg-gray-50 rounded-xl p-8 border border-gray-200"
        >
          <h3 className="text-2xl font-bold text-[#19354a] mb-2">
            {steps[activeIndex].title}
          </h3>
          <div className="w-24 h-1 bg-[#E85A2C] mb-4"></div>
          <p className="text-gray-800 leading-relaxed">
            {steps[activeIndex].description}
          </p>
        </motion.div>
      </div>
    </section>
  );
};


// FAQ Section Component
const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

 const faqs = [
  {
    question: "What services do you offer for doctors and healthcare professionals?",
    answer: "We offer comprehensive Growth Ecosystem services for doctors including healthcare website design, Medical SEO, Google Ads for clinics, social media marketing, online reputation management, YouTube marketing, and patient lead generation. Our team creates professional, HIPAA-aware marketing strategies that help you attract more patients."
  },
  {
    question: "How do you ensure creativity and uniqueness in healthcare marketing?",
    answer: "Our creative team combines healthcare industry insights with innovative digital strategies. We conduct thorough research on your specialty, analyze competitor strategies, and understand your unique medical expertise to create original content that builds patient trust. From educational health content to compelling patient testimonials, we ensure every campaign reflects your professional credibility."
  },
  {
    question: "Which digital platforms do you specialize in for doctor marketing?",
    answer: "We specialize in all major platforms relevant to healthcare including Google (Search & Maps), Facebook, Instagram, YouTube, LinkedIn, and healthcare-specific platforms like Practo and Lybrate. We also manage Google Business Profile optimization and review management to ensure your practice is visible where patients search."
  },
  {
    question: "How do you handle patient privacy in digital marketing?",
    answer: "We take patient privacy very seriously. All our marketing strategies are designed with healthcare compliance in mind. We never use real patient data without consent, ensure all testimonials are properly authorized, and follow best practices for healthcare advertising. Your reputation and patient trust are our top priorities."
  },
  {
    question: "What makes Docmize different from other Growth Ecosystem companies?",
    answer: "Our exclusive focus on healthcare marketing sets us apart. With 10+ years of experience working with 75+ doctors across India, we understand the unique challenges of medical marketing. We know what works for dentists vs cardiologists vs dermatologists. Our specialized expertise, combined with proven results and 90% client retention rate, makes us the trusted choice for doctors."
  }
];
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-8 items-start">
          
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex items-start justify-center sticky top-8"
          >
           <img 
  src="/images/faq-img.png" 
  alt="FAQ"
  className="w-full max-w-[350px] max-h-[500px] object-contain"
  loading="eager"
/>
          </motion.div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
              >
                <div
                  onClick={() => toggleFAQ(index)}
                  className={`flex items-center gap-4 p-5 rounded-lg cursor-pointer transition-all duration-300 ${
                    activeIndex === index 
                      ? 'bg-[#19354a]' 
                      : 'bg-gray-100 hover:bg-gray-200'
                  }`}
                >
                  <span className={`text-2xl font-bold min-w-[40px] ${
                    activeIndex === index ? 'text-white' : 'text-[#E85A2C]'
                  }`}>
                    {index + 1}
                  </span>
                  
                  <p className={`flex-1 font-semibold text-base ${
                    activeIndex === index ? 'text-white' : 'text-[#19354a]'
                  }`}>
                    {faq.question}
                  </p>
                  
                  <motion.svg 
                    animate={{ rotate: activeIndex === index ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                    className={`w-6 h-6 flex-shrink-0 ${
                      activeIndex === index ? 'text-white' : 'text-gray-500'
                    }`}
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </motion.svg>
                </div>

                <motion.div
                  initial={false}
                  animate={{
                    height: activeIndex === index ? 'auto' : 0,
                    opacity: activeIndex === index ? 1 : 0
                  }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <div className="p-5 bg-white border border-gray-200 border-t-0 rounded-b-lg">
                    <p className="text-gray-800 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </motion.div>
              </motion.div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

     
      <section className="relative bg-white min-h-[80vh] overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 pt-0 md:pt-0 md:pb-4">
          <div className="grid lg:grid-cols-2 gap-8 items-start">
            
            <div className="pt-4 lg:pt-8">
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="text-[#19354a] font-semibold text-lg mb-4"
              >
                Partner With Result Driven
              </motion.p>
              
              <motion.h1 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#19354a] leading-tight mb-6"
              >
               The Only Growth Ecosystem Created Exclusively for <span className= "text-4xl md:text-5xl lg:text-7xl text-[#39a5d3]">Doctors</span> in India
              </motion.h1>
              
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="text-gray-800 font-medium text-lg mb-2"
              >
                Looking for the best Growth Ecosystem company for your healthcare practice?
              </motion.p>
              
              

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
              >
                <p className="text-[#19354a] font-semibold text-lg mb-6">Our Efforts Help Businesses to Achieve:</p>
                <div className="flex gap-10 mb-10">
                  <div>
                    <p className="text-4xl md:text-5xl font-bold text-[#19354a]">{countUp.traffic}%</p>
                    <p className="text-gray-700 text-sm mt-1">Increment in Organic<br/>Search Traffic</p>
                  </div>
                  <div>
                    <p className="text-4xl md:text-5xl font-bold text-[#19354a]">{countUp.keywords}+</p>
                    <p className="text-gray-700 text-sm mt-1">Keywords</p>
                  </div>
                  <div>
                    <p className="text-4xl md:text-5xl font-bold text-[#19354a]">{countUp.leads}%</p>
                    <p className="text-gray-700 text-sm mt-1">Increase in leads</p>
                  </div>
                </div>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="flex gap-4"
              >
                <Link to="/contact" className="px-8 py-4 bg-[#19354a] text-white rounded-md font-semibold hover:bg-[#0f2133] transition-all">
                  Get A Free Consultation
                </Link>
                <Link to="/services" className="px-8 py-4 border-2 border-[#19354a] text-[#19354a] rounded-md font-semibold hover:bg-[#19354a] hover:text-white transition-all">
                  View Services
                </Link>
              </motion.div>
            </div>

            <div className="hidden lg:block relative h-[600px] lg:h-[650px]">
              
              <div className="absolute left-0 top-[38%] z-0">
                <div className="grid grid-cols-5 gap-[6px]">
                  {[...Array(25)].map((_, i) => (
                    <div key={i} className="w-[6px] h-[6px] rounded-full bg-[#19354a] opacity-60" />
                  ))}
                </div>
              </div>

              <div className="absolute inset-0 flex items-end justify-center z-10">
                <img 
                  src="/images/Header.png" 
                  alt="Business professional" 
                  className="h-[580px] w-auto object-contain mix-blend-multiply"
                  style={{ filter: 'drop-shadow(0 0 0 transparent)' }}
                />
              </div>

<motion.div 
  initial={{ opacity: 0, scale: 0, y: 30 }}
  animate={{ opacity: 1, scale: 1, y: 0 }}
  transition={{ duration: 0.6, delay: 1.0, type: "spring", stiffness: 120 }}
  className="absolute left-[10%] top-[30%] z-30 bg-white rounded-xl p-3"
  style={{ 
    border: '2px solid #19354a',
    boxShadow: '0 6px 16px rgba(0,0,0,0.08)'
  }}
>
  <div className="flex flex-col items-center text-center">
    <div className="w-9 h-9 bg-[#39a5d3]/20 rounded-lg flex items-center justify-center mb-1">
      <svg className="w-5 h-5 text-[#39a5d3]" fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14l4-4h12c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
      </svg>
    </div>
    <p className="text-sm font-semibold text-[#19354a]">Healthcare</p>
    <p className="text-xs text-gray-500">Focused Expertise</p>
  </div>
</motion.div>

<motion.div 
  initial={{ opacity: 0, scale: 0, y: 30 }}
  animate={{ opacity: 1, scale: 1, y: 0 }}
  transition={{ duration: 0.6, delay: 1.5, type: "spring", stiffness: 120 }}
  className="absolute left-[6%] bottom-[18%] z-30 bg-white rounded-xl p-3"
  style={{ 
    border: '2px solid #19354a',
    boxShadow: '0 6px 16px rgba(0,0,0,0.08)'
  }}
>
  <div className="flex items-center gap-2">
    <div className="w-9 h-9 bg-[#39a5d3]/20 rounded-lg flex items-center justify-center">
      <svg className="w-5 h-5 text-[#39a5d3]" fill="currentColor" viewBox="0 0 24 24">
        <path d="M3 3h18v18H3V3zm16 16V5H5v14h14z"/>
      </svg>
    </div>
    <p className="text-xs font-semibold text-[#19354a] leading-tight">
      Transparent<br/>Reporting
    </p>
  </div>
</motion.div>

<motion.div 
  initial={{ opacity: 0, scale: 0, x: 30 }}
  animate={{ opacity: 1, scale: 1, x: 0 }}
  transition={{ duration: 0.6, delay: 2.0, type: "spring", stiffness: 120 }}
  className="absolute right-[2%] top-[40%] z-30 bg-white rounded-xl p-3"
  style={{ 
    border: '2px solid #19354a',
    boxShadow: '0 6px 16px rgba(0,0,0,0.08)'
  }}
>
  <div className="flex items-center gap-2">
    <div className="w-9 h-9 bg-[#E85A2C]/10 rounded-lg flex items-center justify-center">
      <svg className="w-5 h-5 text-[#E85A2C]" fill="currentColor" viewBox="0 0 24 24">
        <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z"/>
      </svg>
    </div>
    <p className="text-xs font-semibold text-[#19354a] leading-tight">
      Results-Driven<br/>Growth
    </p>
  </div>
</motion.div>

</div>
          
</div>
          </div>
      </section>
      
{/* ABOUT US */}
{/* <section className="py-16" style={{ backgroundColor: "#f1f8fc" }}>

        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
           
            

<motion.div 
  initial={{ opacity: 0, x: -50 }}
  whileInView={{ opacity: 1, x: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 0.6 }}
 
  className="relative flex items-center justify-center bg-transparent"

  
>
  <img 
    // src="/images/About-us.png" 
       src="/images/40.png" 
    alt="about Us" 
    className="w-full max-w-[550px] h-auto block"
  />
</motion.div>

            <div>
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-[#39a5d3] font-semibold text-lg mb-3"
              >
                What makes us unique?
              </motion.p>
              <motion.h2 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="text-3xl lg:text-4xl font-bold text-[#19354a] mb-6 leading-tight"
              >
                Helping Doctors Build a Strong Digital Presence & Grow Their Practice.
              </motion.h2>
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="leading-relaxed mb-8 text-base"
                style={{ color: '#1a1a1a' }}
              >
                In today's digital age, patients search online before choosing a doctor. We, the <strong>top Growth Ecosystem agency for doctors in India</strong>, understand this and know the secret to making your practice shine online. As the best healthcare marketing company, our commitment to growing your patient base goes beyond mere words; it's a steadfast pledge. To bring your dreams of a thriving practice to fruition, we have:
              </motion.p>
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
                className="leading-relaxed mb-8 text-base"
                style={{ color: '#1a1a1a' }}
              >
                To bring your dreams of a thriving practice to fruition, we have built a <strong>comprehensive, results-driven approach that combines strategy, creativity, and compliance.</strong> From enhancing your online visibility to building patient trust, we focus on every touchpoint of the patient journey. Our tailored digital solutions ensure your practice stands out in a competitive healthcare landscape while maintaining the highest ethical and regulatory standards.
                </motion.p>

              <div className="grid grid-cols-2 gap-6">
               
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="py-16" style={{ backgroundColor: "#ffffff" }}>
  <div className="max-w-7xl mx-auto px-6">
    <div className="grid lg:grid-cols-2 gap-8 items-stretch">

      {/* Left — Image */}
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="relative flex items-center justify-center"
        style={{ backgroundColor: "#ffffff" }}
      >
        <img
          src="/images/image.png"
          alt="About Us"
          style={{
            width: '100%',
            maxWidth: '620px',
            height: 'auto',
            minHeight: '480px',
            objectFit: 'contain',
            backgroundColor: '#ffffff',
          }}
        />
      </motion.div>

      {/* Right — Text content */}
      <div className="flex flex-col justify-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-[#39a5d3] font-semibold text-lg mb-3"
        >
          What makes us unique?
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-3xl lg:text-4xl font-bold text-[#19354a] mb-6 leading-tight"
        >
          Helping Doctors Build a Strong Digital Presence & Grow Their Practice.
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="leading-relaxed mb-8 text-base"
          style={{ color: '#1a1a1a' }}
        >
          In today's digital age, patients search online before choosing a doctor. We, the{' '}
          <strong>top Growth Ecosystem agency for doctors in India</strong>, understand this and know
          the secret to making your practice shine online. As the best healthcare marketing company,
          our commitment to growing your patient base goes beyond mere words; it's a steadfast pledge.
          To bring your dreams of a thriving practice to fruition, we have:
          To bring your dreams of a thriving practice to fruition, we have built a{' '}
          <strong>comprehensive, results-driven approach that combines strategy, creativity, and compliance.</strong>{' '}
          From enhancing your online visibility to building patient trust, we focus on every touchpoint
          of the patient journey.
        </motion.p>
        {/* <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="leading-relaxed mb-8 text-base"
          style={{ color: '#1a1a1a' }}
        >
          To bring your dreams of a thriving practice to fruition, we have built a{' '}
          <strong>comprehensive, results-driven approach that combines strategy, creativity, and compliance.</strong>{' '}
          From enhancing your online visibility to building patient trust, we focus on every touchpoint
          of the patient journey.
        </motion.p> */}

        <div className="grid grid-cols-2 gap-6">
          {/* your existing grid content */}
        </div>
      </div>

    </div>
  </div>
</section>

<PressAndMedia />
{/* Goals */}
<section className="relative py-16 overflow-hidden">
  <div 
    className="absolute inset-0"
    style={{
      background: 'linear-gradient(180deg, #f5d5c8 0%, #e8f0ee 30%, #c9e4e0 60%, #b5dcd6 100%)'
    }}
  />
  
  <div className="absolute top-0 left-0 w-full">
    <svg 
      viewBox="0 0 1440 200" 
      className="w-full"
      preserveAspectRatio="none"
      style={{ height: '150px' }}
    >
      <path 
        d="M0,0 L1440,0 L1440,80 Q1200,150 800,100 Q400,50 0,120 Z" 
        fill="#e8b4a0"
        opacity="0.7"
      />
      <path 
        d="M0,0 L1440,0 L1440,60 Q1100,120 700,80 Q300,40 0,100 Z" 
        fill="#f0c4b0"
        opacity="0.5"
      />
    </svg>
  </div>

  <div className="absolute bottom-0 right-0 w-full">
    <svg 
      viewBox="0 0 1440 300" 
      className="w-full"
      preserveAspectRatio="none"
      style={{ height: '250px' }}
    >
      <path 
        d="M500,300 Q800,200 1100,250 Q1300,280 1440,220 L1440,300 Z" 
        fill="#a8d8d0"
        opacity="0.5"
      />
      <path 
        d="M600,300 Q900,220 1200,260 Q1350,290 1440,250 L1440,300 Z" 
        fill="#8fcfc5"
        opacity="0.4"
      />
    </svg>
  </div>

  <div className="relative z-10 max-w-4xl mx-auto px-6 text-center py-8">
    <motion.h2 
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="text-3xl md:text-4xl font-bold text-[#19354a] mb-4"
      style={{ fontStyle: 'italic' }}
    >
      Let's Discuss Your Goals!
    </motion.h2>
    
    <motion.p 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.1 }}
      className="text-gray-800 text-base mb-6 max-w-xl mx-auto"
    >
      Schedule a call with our experts today and see how we can craft the perfect digital strategy for your business.
    </motion.p>
    
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.2 }}
    >
      <Link 
        to="/contact" 
        className="inline-block px-8 py-3 bg-[#19354a] text-white rounded font-semibold hover:bg-[#0f2133] transition-all"
      >
        Let's Connect Today!
      </Link>
    </motion.div>
  </div>
</section>

<section className="relative py-20 bg-white overflow-hidden">
  <div 
    className="absolute inset-0 opacity-[0.15]"
    style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='4' height='4' viewBox='0 0 4 4' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='2' cy='2' r='1' fill='%23a0aec0'/%3E%3C/svg%3E")`,
      backgroundSize: '8px 8px'
    }}
  />
  
  <div 
    className="absolute right-0 top-1/2 -translate-y-1/2 w-[60%] h-[80%] opacity-[0.08]"
    style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 500'%3E%3Cpath fill='%23718096' d='M150,100 Q200,80 250,100 Q300,120 350,100 Q400,80 450,110 Q500,140 520,120 Q540,100 580,110 Q620,120 660,100 Q700,80 750,100 Q800,120 850,90 L850,150 Q800,170 750,150 Q700,130 650,160 Q600,190 550,170 Q500,150 450,180 Q400,210 350,190 Q300,170 250,200 Q200,230 150,200 Z M200,250 Q250,230 300,260 Q350,290 400,270 Q450,250 500,280 Q550,310 600,290 Q650,270 700,300 Q750,330 800,300 L800,350 Q750,380 700,350 Q650,320 600,350 Q550,380 500,350 Q450,320 400,350 Q350,380 300,350 Q250,320 200,350 Z'/%3E%3C/svg%3E")`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'contain'
    }}
  />

  <div className="relative z-10 max-w-7xl mx-auto px-6">
    <div className="grid lg:grid-cols-2 gap-12 items-start">
      
      <motion.div 
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="flex"
      >
        <div className="pr-8 border-r-4 border-[#E85A2C]">
          <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] leading-tight">
            Success Stories<br />
            of Doctors &<br />
            Healthcare<br />
            Professionals
          </h2>
        </div>
      </motion.div>

      <motion.div 
        initial={{ opacity: 0, x: 30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        <p className="text-gray-800 leading-relaxed text-base">
          We know how vital it is for doctors to have effective Growth Ecosystem strategies. Whether you're a dentist, dermatologist, cardiologist, or running a multi-specialty hospital, we have the right recipe to make your practice stand out. With a deep understanding of healthcare marketing trends, we tailor data-driven strategies that drive patient appointments and trust. This has helped us at Docmize to create a path of success for hundreds of doctors across India. As the best <strong className="text-[#19354a]">Growth Ecosystem company for doctors in India</strong>, we focus on innovative solutions, Medical SEO, social media, and performance marketing to maximize your reach. We craft the right marketing strategies to achieve the required growth so that your practice soars high. With incredible services, we aid the growth of:
        </p>
      </motion.div>

    </div>
  </div>
</section>
    

{/*     
<section className="py-12 bg-white">
  <div className="max-w-7xl mx-auto px-6">
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.4, delay: 0.03 }}
className="flex items-center justify-center p-4 border border-gray-200 rounded-md bg-white hover:shadow-lg transition-shadow duration-300"
      >
        <img 
          src="https://www.newvisiondigital.co/static/media/logo-1.88452ecc14f0076452b3.jpg"
          alt="Client 1"
          className="max-h-20 w-auto object-contain"
        />
      </motion.div>

      {[2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((num) => (
        <motion.div
          key={num}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: num * 0.03 }}
         className="flex items-center justify-center p-4 border border-gray-200 rounded-md bg-white hover:shadow-lg transition-shadow duration-300"
        >
          <img 
            src={`/images/${num}.png`}
            alt={`Client ${num}`}
         className="max-h-66 w-auto object-contain"
          />
        </motion.div>
      ))}
    </div>
  </div>
</section> */}



<section className="relative py-20 overflow-hidden">
  <div 
    className="absolute inset-0"
    style={{
      background: 'linear-gradient(135deg, #1e0a3c 0%, #2d1b69 20%, #1a1a6e 40%, #1e3a8a 60%, #1e40af 80%, #2563eb 100%)'
    }}
  />
  
  <div className="absolute inset-0 overflow-hidden">
    <div 
      className="absolute w-[800px] h-[600px] -left-40 top-0 opacity-10"
      style={{
        background: 'linear-gradient(45deg, transparent 0%, rgba(139, 92, 246, 0.3) 50%, transparent 100%)',
        transform: 'rotate(-15deg)'
      }}
    />
    <div 
      className="absolute w-[600px] h-[800px] left-20 -top-20 opacity-10"
      style={{
        background: 'linear-gradient(30deg, transparent 0%, rgba(59, 130, 246, 0.4) 50%, transparent 100%)',
        transform: 'rotate(-20deg)'
      }}
    />
    <div 
      className="absolute w-[400px] h-[600px] left-1/4 top-1/4 opacity-5"
      style={{
        background: 'linear-gradient(60deg, transparent 0%, rgba(147, 51, 234, 0.5) 50%, transparent 100%)',
        transform: 'rotate(-25deg)'
      }}
    />
  </div>

  <div className="absolute bottom-0 left-0 w-full">
    <svg 
      viewBox="0 0 1440 150" 
      className="w-full"
      preserveAspectRatio="none"
      style={{ height: '100px' }}
    >
      <path 
        d="M0,150 L0,100 Q360,20 720,80 Q1080,140 1440,60 L1440,150 Z" 
        fill="#f3f4f6"
      />
    </svg>
  </div>

  <div className="relative z-10 max-w-7xl mx-auto px-6">
    <div className="grid lg:grid-cols-3 gap-8 items-center">
      
      <div className="lg:col-span-1">
        <motion.h2 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-3xl lg:text-4xl xl:text-5xl font-bold text-white leading-tight mb-8"
        >
          Get more patients to visit your clinic with our premium <span className="text-[#39a5d3]">Healthcare SEO</span>
        </motion.h2>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Link 
            to="/services" 
            className="inline-block px-6 py-3 bg-[#19354a] text-white rounded font-semibold hover:bg-[#0f2133] transition-all"
          >
            Rank #1 on Google for Your Medical Specialty
          </Link>
        </motion.div>
      </div>

      <div className="lg:col-span-2 grid md:grid-cols-2 gap-6">
        
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300"
        >
          <div className="flex items-start gap-4 mb-4">
            <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-[#19354a]">Medical SEO & Local Search</h3>
          </div>
          <p className="text-gray-800 text-sm leading-relaxed">
            Dominate local searches when patients look for doctors near them. Our <span className="text-[#39a5d3]">Healthcare SEO experts</span> optimize your Google Business Profile and website for maximum visibility.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300"
        >
          <div className="flex items-start gap-4 mb-4">
            <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg className="w-8 h-8 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-[#19354a]">Google Ads for Doctors</h3>
          </div>
          <p className="text-gray-800 text-sm leading-relaxed">
            Get instant patient inquiries with targeted Google Ads campaigns designed specifically for healthcare professionals and clinics.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300"
        >
          <div className="flex items-start gap-4 mb-4">
            <div className="w-14 h-14 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg className="w-8 h-8 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-[#19354a]">Social Media for Healthcare</h3>
          </div>
          <p className="text-gray-800 text-sm leading-relaxed">
            Build trust and engage with patients through strategic social media marketing on Facebook, Instagram, and LinkedIn for doctors.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300"
        >
          <div className="flex items-start gap-4 mb-4">
            <div className="w-14 h-14 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-[#19354a]">Website Design for Clinics</h3>
          </div>
          <p className="text-gray-800 text-sm leading-relaxed">
            Professional, mobile-friendly websites for doctors that convert visitors into patients. We design for all specialties and hospital types.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300"
        >
          <div className="flex items-start gap-4 mb-4">
            <div className="w-14 h-14 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg className="w-8 h-8 text-red-500" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
              </svg>
            </div>
            <h3 className="text-xl font-bold text-[#19354a]">YouTube Marketing for Doctors</h3>
          </div>
          <p className="text-gray-800 text-sm leading-relaxed">
            Establish yourself as an expert with educational health videos. We optimize your YouTube channel for maximum reach and patient trust.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300"
        >
          <div className="flex items-start gap-4 mb-4">
            <div className="w-14 h-14 bg-cyan-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <svg className="w-8 h-8 text-cyan-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-[#19354a]">Online Reputation Management</h3>
          </div>
          <p className="text-gray-800 text-sm leading-relaxed">
            Manage and improve your online reviews on Google, Practo, and other healthcare platforms. Build a 5-star reputation that attracts patients.
          </p>
        </motion.div>

      </div>
    </div>
  </div>
</section>



<section className="py-16 bg-gray-50">
  <div className="max-w-7xl mx-auto px-6">
    <div className="grid lg:grid-cols-2 gap-12 items-center">
      
      <TestimonialSlider />

      <div>
        <motion.h2 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] leading-tight mb-4"
        >
          75+ Doctors Trust <span className="text-[#39a5d3]">Docmize</span> for their Digital Growth
        </motion.h2>
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="flex items-center gap-1 mb-2"
        >
          {[...Array(5)].map((_, i) => (
            <svg key={i} className="w-6 h-6 text-yellow-400" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
            </svg>
          ))}
        </motion.div>
        
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-gray-800 text-lg mb-8"
        >
          150+ Reviews based on
        </motion.p>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="flex flex-wrap items-center gap-8 mb-8"
        >
          <span className="text-2xl font-bold text-[#1877F2]">facebook</span>
          
          <span className="text-2xl font-bold">
            <span className="text-[#4285F4]">G</span>
            <span className="text-[#EA4335]">o</span>
            <span className="text-[#FBBC05]">o</span>
            <span className="text-[#4285F4]">g</span>
            <span className="text-[#34A853]">l</span>
            <span className="text-[#EA4335]">e</span>
          </span>
          
          <span className="text-2xl font-bold text-gray-900">Clutch</span>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <Link 
            to="/contact" 
            className="inline-block px-8 py-4 bg-[#19354a] text-white rounded font-semibold hover:bg-[#0f2133] transition-all"
          >
            Get a Free Consultation
          </Link>
        </motion.div>
      </div>
    </div>
  </div>
</section>







<section className="py-16 bg-white">
  <div className="max-w-7xl mx-auto px-6">
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="text-center mb-6"
    >
      <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-6">
        How Can Your Practice Grow with Us?
      </h2>
      <p className="text-gray-800 max-w-5xl mx-auto leading-relaxed">
        In an era where patients search online before visiting a doctor, having a strong digital presence is essential. Whether you're planning to revamp your existing website or create a new one, as the best Growth Ecosystem agency for doctors in India, we are committed to delivering high-quality solutions tailored to healthcare professionals. By keeping your practice goals in mind and the current stage of your digital presence, we create and implement strategies that can boost patient appointments, increase trust, and grow your practice. With our result-oriented solution, we ensure to:
      </p>
    </motion.div>

    <div className="grid md:grid-cols-3 gap-8 mt-12">
      
      <motion.div
        initial={{ opacity: 0, y: 50, scale: 0.9 }}
        whileInView={{ opacity: 1, y: 0, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.1 }}
        whileHover={{ y: -10, boxShadow: "0 20px 40px rgba(232, 90, 44, 0.15)" }}
        className="bg-white rounded-2xl p-8 border-2 border-[#19354a] transition-all duration-300 group cursor-pointer"
      >
        <motion.div 
          className="mb-6"
          whileHover={{ rotate: [0, -10, 10, 0] }}
          transition={{ duration: 0.5 }}
        >
          <div className="w-20 h-20 bg-gradient-to-br from-[#19354a]/10 to-[#19354a]/5 rounded-2xl flex items-center justify-center">
            <img 
              src="/images/brand1.png" 
              alt="Get More Leads"
              className="w-14 h-14 object-contain"
              loading="eager"
            />
          </div>
        </motion.div>
        <h3 className="text-xl font-bold text-[#19354a] mb-4 group-hover:text-[#39a5d3] transition-colors">Get More Patient Inquiries</h3>
        <p className="text-gray-800 text-sm leading-relaxed">
          For us, patient lead generation is an integral element of our healthcare marketing strategy. We utilize proven techniques including Medical SEO, content marketing, and targeted advertising to attract high-quality patient inquiries that convert into appointments.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 50, scale: 0.9 }}
        whileInView={{ opacity: 1, y: 0, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.2 }}
        whileHover={{ y: -10, boxShadow: "0 20px 40px rgba(232, 90, 44, 0.15)" }}
        className="bg-white rounded-2xl p-8 border-2 border-[#19354a] transition-all duration-300 group cursor-pointer"
      >
        <motion.div 
          className="mb-6"
          whileHover={{ rotate: [0, -10, 10, 0] }}
          transition={{ duration: 0.5 }}
        >
          <div className="w-20 h-20 bg-gradient-to-br from-[#22C55E]/10 to-[#22C55E]/5 rounded-2xl flex items-center justify-center">
            <img 
              src="/images/brand2.png" 
              alt="Increase Sales"
              className="w-14 h-14 object-contain"
              loading="eager"
            />
          </div>
        </motion.div>
        <h3 className="text-xl font-bold text-[#19354a] mb-4 group-hover:text-[#39a5d3] transition-colors">Increase Appointments</h3>
        <p className="text-gray-800 text-sm leading-relaxed">
          At Docmize, we help you build patient trust by utilizing the right digital strategies. Our data-driven approach helps optimize your patient journey from online search to booking an appointment at your clinic.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 50, scale: 0.9 }}
        whileInView={{ opacity: 1, y: 0, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.3 }}
        whileHover={{ y: -10, boxShadow: "0 20px 40px rgba(232, 90, 44, 0.15)" }}
        className="bg-white rounded-2xl p-8 border-2 border-[#19354a] transition-all duration-300 group cursor-pointer"
      >
        <motion.div 
          className="mb-6"
          whileHover={{ rotate: [0, -10, 10, 0] }}
          transition={{ duration: 0.5 }}
        >
          <div className="w-20 h-20 bg-gradient-to-br from-[#3b82f6]/10 to-[#3b82f6]/5 rounded-2xl flex items-center justify-center">
            <img 
              src="/images/brand3.png" 
              alt="Build Brand Awareness"
              className="w-14 h-14 object-contain"
              loading="eager"
            />
          </div>
        </motion.div>
        <h3 className="text-xl font-bold text-[#19354a] mb-4 group-hover:text-[#39a5d3] transition-colors">Build Your Medical Brand</h3>
        <p className="text-gray-800 text-sm leading-relaxed">
          In today's digital world, building your personal brand as a doctor is crucial. Our team will help you establish authority through strategic social media marketing, health content creation, and consistent messaging across all platforms.
        </p>
      </motion.div>

    </div>
  </div>
</section>

<HowWeWorkSection />

<section className="py-16 bg-white">
  <div className="max-w-7xl mx-auto px-6">
    
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="text-center mb-12"
    >
      <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
        Our <span className="text-[#39a5d3]">Services</span>
      </h2>
      <p className="text-gray-800 max-w-3xl mx-auto">
        Comprehensive digital solutions to help your business grow and succeed online.
      </p>
    </motion.div>

    <div className="grid md:grid-cols-3 gap-8">
      
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="group"
      >
        <div className="overflow-hidden rounded-2xl mb-5">
          <img 
            src="/images/35.png" 
            alt="Digital Platforms & Experience"
            className="w-full h-[280px] object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <h3 className="text-xl font-bold text-[#19354a] mb-3">
          Healthcare Website Design
        </h3>
        <p className="text-gray-800 leading-relaxed mb-4">
          Your online presence is highly dependent on the performance of your website. We build stunning, patient-friendly websites for doctors and clinics that drive appointments.
        </p>
        <Link 
          to="/services/digital-platforms-experience" 
          className="inline-flex items-center gap-2 text-[#19354a] font-semibold hover:underline"
        >
          Read More
          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </Link>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="group"
      >
        <div className="overflow-hidden rounded-2xl mb-5">
          <img 
            src="/images/36.png" 
            alt="Marketing & Client Acquisition"
            className="w-full h-[280px] object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <h3 className="text-xl font-bold text-[#19354a] mb-3">
          Patient Acquisition & Marketing
        </h3>
        <p className="text-gray-800 leading-relaxed mb-4">
          Be present where your patients are. We help you make a mark on social media platforms and Google, generating quality patient inquiries for your practice.
        </p>
        <Link 
          to="/services/marketing-client-acquisition" 
          className="inline-flex items-center gap-2 text-[#19354a] font-semibold hover:underline"
        >
          Read More
          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </Link>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.3 }}
        className="group"
      >
        <div className="overflow-hidden rounded-2xl mb-5">
          <img 
            src="/images/32.png" 
            alt="Growth & Visibility"
            className="w-full h-[280px] object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <h3 className="text-xl font-bold text-[#19354a] mb-3">
          Medical SEO & Visibility
        </h3>
        <p className="text-gray-800 leading-relaxed mb-4">
          Want to rank #1 when patients search for your specialty? Our Medical SEO services help you get found by patients actively searching for doctors like you.
        </p>
        <Link 
          to="/services/growth-visibility" 
          className="inline-flex items-center gap-2 text-[#19354a] font-semibold hover:underline"
        >
          Read More
          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </Link>
      </motion.div>

    </div>

  </div>
</section>

<FAQSection />


<section className="py-16 bg-white">
  <div className="max-w-7xl mx-auto px-6">
    <div className="grid lg:grid-cols-2 gap-12 items-center">
      
      <motion.div
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-6">
          Ready to Grow Your Practice?
        </h2>
        <p className="text-gray-900 leading-relaxed mb-8">
          Digital marketing is a powerful tool for growing your medical practice. In today's fast-paced world, it's essential to have a strong online presence. As the <strong>top Growth Ecosystem agency for doctors in India</strong>, we at Docmize specialize in creating tailored strategies for healthcare professionals, ensuring your practice gets the attention it deserves. To speak with one of our healthcare marketing strategists, please get in touch with us. With our help, your practice will attract more patients. We promise a marketing strategy that will help you stand out in your specialty.
        </p>
        
        <motion.a
          href="tel:+918920845297"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="inline-flex items-center gap-3 px-6 py-3 border-2 border-[#19354a] text-[#19354a] rounded-lg font-semibold hover:bg-[#19354a] hover:text-white transition-all duration-300"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          +91 89208 45297
        </motion.a>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100"
      >
        <h3 className="text-2xl font-bold text-[#19354a] text-center mb-2">Let's Get</h3>
        <h4 className="text-xl font-bold text-[#19354a] text-center mb-8">On A Discovery Call</h4>
        
        <form onSubmit={handleDiscoverySubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <input
              type="text"
              name="firstName"
              placeholder="First Name*"
              value={discoveryFormData.firstName}
              onChange={(e) => setDiscoveryFormData({...discoveryFormData, firstName: e.target.value})}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#19354a] transition-colors"
              required
              disabled={isSubmittingDiscovery}
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name*"
              value={discoveryFormData.lastName}
              onChange={(e) => setDiscoveryFormData({...discoveryFormData, lastName: e.target.value})}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#19354a] transition-colors"
              required
              disabled={isSubmittingDiscovery}
            />
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <input
              type="email"
              name="email"
              placeholder="Email*"
              value={discoveryFormData.email}
              onChange={(e) => setDiscoveryFormData({...discoveryFormData, email: e.target.value})}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#19354a] transition-colors"
              required
              disabled={isSubmittingDiscovery}
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone*"
              value={discoveryFormData.phone}
              onChange={(e) => setDiscoveryFormData({...discoveryFormData, phone: e.target.value})}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#19354a] transition-colors"
              required
              disabled={isSubmittingDiscovery}
            />
          </div>
          
          <select
            name="service"
            value={discoveryFormData.service}
            onChange={(e) => setDiscoveryFormData({...discoveryFormData, service: e.target.value})}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#19354a] transition-colors text-gray-500"
            required
            disabled={isSubmittingDiscovery}
          >
            <option value="">Select Services*</option>
            <option value="Patient Growth & Visibility">Patient Growth & Visibility (SEO)</option>
            <option value="Ads & Patient Acquisition">Ads & Patient Acquisition</option>
            <option value="Social Media & Branding">Social Media & Branding</option>
            <option value="Lead Management & Virtual Assistants">Lead Management & Virtual Assistants</option>
            <option value="Patient Communication & Analytics">Patient Communication & Analytics</option>
            <option value="Websites, Apps & Technology">Websites, Apps & Technology</option>
            <option value="Creative, Media & Content">Creative, Media & Content</option>
            <option value="Systems, Compliance & Consulting">Systems, Compliance & Consulting</option>
            <option value="Other">Other</option>
          </select>
          
          <textarea
            name="message"
            placeholder="Message*"
            rows={4}
            value={discoveryFormData.message}
            onChange={(e) => setDiscoveryFormData({...discoveryFormData, message: e.target.value})}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#19354a] transition-colors resize-none"
            required
            disabled={isSubmittingDiscovery}
          ></textarea>
          
          <motion.button
            type="submit"
            disabled={isSubmittingDiscovery}
            whileHover={{ scale: isSubmittingDiscovery ? 1 : 1.02 }}
            whileTap={{ scale: isSubmittingDiscovery ? 1 : 0.98 }}
            className={`w-full md:w-auto px-8 py-3 rounded-lg font-semibold transition-all duration-300 ${
              isSubmittingDiscovery
                ? 'bg-gray-400 text-white cursor-not-allowed'
                : 'bg-[#19354a] text-white hover:bg-[#0f2133]'
            }`}
          >
            {isSubmittingDiscovery ? 'Submitting...' : 'Submit'}
          </motion.button>
        </form>
      </motion.div>

    </div>
  </div>
</section>

       <Footer />
    </div>
  
  );
};

export default Home;